<template>
  <div class="W100" style="display: inline-block">
    <!--  轮播图   -->
    <Banner v-if="swiperList.length" :banner="swiperList"/>
    <!--  资讯列表   -->
    <ul class="news-list content-1200 radius-8">
      <li v-for="item in newsList" :key="item.id" class="flex-nowrap">
        <img class="radius-8 margin-r40" :src="item.imageUrl" alt="">
        <div class="cursor" @click="$router.push({path:'/home/news/info',query: {newsId:item.id}})">
          <div class="title color-level1 fontWeight-500 fontSize18">{{ item.title }}</div>
          <div class="color-level3  fontSize12 margin-b20">{{ item.type | newsType() }}
            {{ item.publishTime | parseTime() }}
          </div>
          <div class="desc color-level2 fontSize14 ellipsis4">{{ item.description }}</div>
        </div>
      </li>
      <Pagination
          class="text-center"
          @current-change="currentChange"
          :page-size="pageInfo.perPage"
          :total="pageInfo.total"
          layout="prev, pager, next"
          prev-text="上一页"
          next-text="下一页"
      />
    </ul>
  </div>
</template>
<script>
import {singleNewsSever} from "@/common/api-config";
import Banner from "@/components/common/Banner.vue";
import Pagination from "@/components/common/Pagination.vue";

export default {
  components: {Banner, Pagination},
  created() {
    this.queryBannerList(); //获取banner
    this.queryList(); //获取APP应用list
  },
  data() {
    return {
      swiperList: [], //banner
      newsList: [],//资讯
      pageInfo: {
        total: 99,
        page: 1,
        perPage: 4,
      },
    };
  },
  methods: {
    //获取banner
    queryBannerList() {
      singleNewsSever.queryBannerList({
        type: 2,
        num: 4,
      }).then(res => {
        if (res.code == 0) {
          this.swiperList = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //获取资讯list
    queryList() {
      singleNewsSever.queryNewsList({
        page: this.pageInfo.page,
        perPage: this.pageInfo.perPage,
      })
          .then((res) => {
            if (res.code == 0) {
              this.newsList = res.data.data;
              this.pageInfo.total = res.data.total;
            } else {
              this.newsList = [];
              this.pageInfo.total = 0;
              this.$message.error(res.message);
            }
          });
    },
    //翻页
    currentChange(val) {
      this.pageInfo.page = val;
      this.queryList();
    },
  },
};
</script>

<style scoped lang="scss">
.news-list {
  margin-top: 60px;
  margin-bottom: 80px;
  padding: 60px 96px 60px 40px;
  background: #FFFFFF;

  li {
    &:not(:last-of-type) {
      margin-bottom: 80px;
    }

    &:last-of-type {
      margin-bottom: 60px;
    }
    & > div {
      flex: 1;
      min-width: 0;
    }

    .title {
      margin-bottom: 12px;
    }

    .desc {
      line-height: 24px;
    }
  }

  img {
    width: 240px;
    height: 160px;
  }
}

</style>

